
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Išvalyti`,
'deleteKey': `⌦ Ištrinti`,
'downKey': `↓ žemyn`,
'endKey': `⤓ Pabaiga`,
'enterKey': `Įveskite`,
'escapeKey': `⎋ Pabėgimas`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Sukurti 
          <code>LICENCIJA 
          </code> failą 
        `,
'homeKey': `⤒ Pagrindinis puslapis`,
'keyCommand': `⌘ Komanda / Win`,
'keyControl': `^ Kontrolė`,
'keyOption': `⌥ Pasirinktis / Alt`,
'keyShift': `⇧ Pamaina`,
'leftKey': `← Kairė`,
'pagedownKey': `▼ Pagedown`,
'pageupKey': `▲ puslapio atnaujinimas`,
'rightKey': `→ Teisė`,
's00065e45db8c0441': `Išsamesnės informacijos ieškokite kūrėjų įrankiuose`,
's001dd78415a91fa0': `Slinkimo juostos griovelis`,
's002fa7d1054ed082': `Pasienio langelis`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kazachų`,
's01b56d233c6c5cac': `Skirstymas`,
's01d32b35baa3b676': `Autorius`,
's02106cc2ef0e7578': `Naujas kaištis...`,
's02ab1ea8e5100fc1': `Pažymėti pasirinkimą kaip "dvikryptį pakeitimą`,
's0312976fe9da5951': `Mygtukas`,
's03608a32f05eded2': `Priartinimas suspaudžiant`,
's036d35e03be98d22': `Matematinis gylis`,
's037b1dc850a89273': `Alternatyva pagal`,
's0396202b716732ec': `Pažymėkite pasirinkimą kaip perbrauktą`,
's03f49e598ffb11cc': `Lenkų kalba`,
's0448f1059fa01720': `Išsaugokite, bendrinkite arba atsispausdinkite savo tyrinėjamąjį objektą. Redaguokite informaciją, pavyzdžiui, pavadinimą, kalbą ar licenciją.`,
's0458872c43beadef': `Įterpti eilutę prieš`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Tarpai tarp žodžių`,
's05e9759cfd99c48f': `Pagrįskite`,
's063fa5a0a4903bf4': `Į šoną, iš kairės į dešinę`,
's064339c229374050': `Kodavimas`,
's06634274f19b0572': `Kaiščių pasirinkimas`,
's06743b24499f0035': `Inkaro centras`,
's07808b0ca6da8fef': `Uždrausta svetainė`,
's07970793b21351fd': `"Ruby" bazinis konteineris`,
's079cf7850d9327f0': `Šriftas`,
's07aa10850d9ddcc7': `Forma`,
's07e6118e838b2e23': `Navigacija`,
's0816468df86e4036': `Atidaro nustatymus`,
's082869038c117fe5': `portugalų kalba (Brazilija)`,
's086e6c267ade2609': `Sodrumas`,
's08e12ade32ef8125': `Setsvana`,
's08e6bd98452e6bb9': `Garso`,
's0978fb5ba3145996': `Įterpti sąrašą (be eilės)`,
's09c3f1d21de14ae1': `Pažymėkite pasirinkimą kaip pabrauktą`,
's0a2d91c6720033e9': `Teksto tarpelių apipjaustymas`,
's0a3ddcba94027d95': `Objekto tinkamumas`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Įterpti navigaciją`,
's0a7db790db1fc45c': `Pažymėkite pasirinkimą kaip intervalą`,
's0b1271f50a77dc73': `Turinio langelis`,
's0b24d08ea349b455': `Viskas, ką galite įterpti. Pradžioje yra neinteraktyvūs elementai, pavyzdžiui, sąrašai ar paveikslėliai, o toliau - interaktyvūs elementai, vadinami valdikliais. Naujų galite gauti spustelėję paieškos juostą.`,
's0bdca49248ba4820': `Trumpieji keliai`,
's0befccf152b6c0a9': `Orientuotis į metaduomenis`,
's0c11e479416c8421': `Įterpti lentelės antraštę`,
's0c27336067c59611': `Slinkimo paminkštinimas`,
's0c4593d81f147042': `Bazinis`,
's0c4b2e98d4ab7f5a': `Programėlės komandos`,
's0c883713b83616a8': `Išsaugoti aktyvųjį dokumentą`,
's0ca5c0460199cba1': `Santrumpa`,
's0cf10c4f40588f8d': `Lentelės antraštė`,
's0d86afa3c6a1e28b': `Lankstumo kryptis`,
's0dad143dff0079fc': `Malajalamas`,
's0db05bd7ba6fff96': `Jūsų tyrinėjamas dokumentas. Čia galite rašyti tekstą, jį kopijuoti ir įklijuoti, redaguoti ir t. t.`,
's0dc452999c129e15': `Įjungti tiesioginį perkrovimą`,
's0de0febab8a4beaf': `Klaida skaitant šį paketą`,
's0e44968489e076a8': `Kinų`,
's0e4862e87c7d53ce': `Pažymėti pasirinkimą kaip citatą`,
's0e6ea8870dbddab2': `Dokumentų komandos`,
's0ee28503778e4c0c': `Paskutinis bazinis lygis`,
's0ef01c03299bbb83': `Dekoravimas`,
's0f17f32919661cff': `Mongoliškas`,
's0f350bc4e538e3ea': `Žodžiai`,
's105a06836c40fcb4': `Nustatykite filtrus, spalvą ir pasirinktų elementų maišymą`,
's106b274b5af798e5': `Sakiniai`,
's1082e1649793dca9': `Pažymėti pasirinkimą kaip apibrėžtą terminą`,
's10f3845975a0351e': `Redaguoti metaduomenis`,
's1125d159f7e64df5': `Ekranas`,
's11326fd2590f4e5e': `Numatytoji`,
's1155ec07a221e739': `Slankiklio juostos`,
's1173bf7a3e0b74c9': `Minimalus (y)`,
's1177237a3e0e548c': `Minimalus (x)`,
's1219d97b49650c05': `Matomumas`,
's123bea44f38abccf': `Objekto įterpimas`,
's1245e2cb9f20197e': `Suderinti`,
's12946ec1b850962c': `Įterpti stulpelį po`,
's1351209ef74ee729': `Išskleisti visus stulpelius`,
's13c60cb409e8cb6f': `Sulygiuoti centrą`,
's13ebd619c8a06a6d': `Tinklelio automatinės eilutės`,
's13ef8ca26ca8861b': `Pjūvio elementas`,
's151bc2eea7a032a4': `-nepakeistas-`,
's153bc3c3aa39587b': `Stalo galvutė`,
's156647179b21d351': `Įterpti lentelės korpusą`,
's158b6ec6b1fffcb2': `Pertrauka po`,
's15d0c0657c1ee08c': `API raktas`,
's1626a7e10a9f9dcc': `Nustato pasirinkimo šrifto šeimą`,
's1637c7d1a30629e2': `Pasienio langelis`,
's1641ab440bf4daa4': `Atnaujinti šį valdiklių paketą`,
's166bd56d19670a72': `Padidinti`,
's1696c76a23c0834e': `Išplėstinis: Paketų tvarkyklėje rodyti paketus su tokiomis versijomis kaip 0.x.x`,
's16b9446e3a70e1f4': `Atributai`,
's16f205466761e583': `Nėra optinio šrifto dydžio`,
's16f2f1c2c516d307': `Atidaryti dokumentą`,
's1749014f3f87fa6a': `Ištempkite`,
's17597a8bb4810524': `Licencija`,
's17bfaaa4e7528bc7': `Baškirų`,
's17fb3f4805f4f4b9': `Pašalinti lauką`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Sukurti paketą`,
's18d5c44aae3dc82a': `Internete, kai redaguojate`,
's1988d71ef8060edf': `Lentelės eilutės įterpimas`,
's19abee1277c9bca2': `Samoan`,
's19daf2f26c19543d': `Kontūras`,
's1a1acc902e6668e0': `Rodyti išplėstinį teksto formatavimą`,
's1a5230a71d9285c1': `Užfiksuoti`,
's1aa1cb63ad44bc6f': `Stulpelio tarpas`,
's1af8b67d1c85c811': `Tarpas tarp`,
's1b4a36fce2456660': `Šriftų šeima`,
's1c246045629b0016': `Pažymėti pasirinkimą kaip ištrynimą`,
's1c3fc313a9184670': `Viešoji nuoroda`,
's1c65f5004a07dcfa': `škotų galisų kalba`,
's1c690963f1e2df00': `Konkrečiai platformai būdinga išvaizda`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Norite trumpos ekskursijos su gidu?`,
's1d19244f549ec535': `Švietimas`,
's1d5c7b28e8b50d6d': `Asocijuotas laipsnis.`,
's1db591f5a54dbfd3': `Turinio langelis`,
's1dbb9f50e16c92a3': `Ribos spindulys`,
's1dfb744260fb3a01': `Dvikryptė izoliacija`,
's1e9c2c654732cc5f': `Baltarusijos`,
's1eaccbf2d6af8ab5': `Informacija`,
's1efbfc3937d565bd': `Pagrindinė informacija`,
's1f2b49c1bca2035d': `Katalonų kalba`,
's1f74bdf32b51a5fc': `Fono paveikslėlis`,
's1f7698c061c208c9': `Atviras`,
's1f8e59d0624842ff': `Kanados`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Korsikos`,
's21d61916eb8d137d': `Lentelės korpusas`,
's21d723a1dbcd89c8': `Javos`,
's21f8a2eaf5a70749': `Įterpti etiketę`,
's2206c42e5b835e6e': `Pažymėti pasirinkimą kaip santrumpą`,
's22a2348c46a912a0': `Įterpti skyrių`,
's233ae776268cd44b': `Verslas`,
's236ed7ba747099b0': `Šrifto svoris`,
's2474e7fb1aec9f05': `Testas`,
's2492f5fb1b05b45e': `Tekstas`,
's24949d7adbb5a098': `Įrankių dėžutė`,
's252a52330d32b900': `Metaduomenys`,
's2540844a4bc4d9ba': `Reikia nurodyti autorystę?`,
's255857544a9d5ec0': `Iš naujo nustatyti`,
's255c77900f2b5e0f': `Spalvų schema`,
's256ab831a48c941c': `Pašalina visą teksto formatavimą iš pasirinkimo`,
's2591806d7b222591': `Iš naujo nustatyti pakeitimus`,
's25e1a07e454c2c11': `Tinklelis`,
's262abbaf1d05f009': `Švelni šviesa`,
's266935f2447fcd98': `Per kairę`,
's268ecd1cef45a9a8': `Ar tikrai?`,
's2692bc028fed91f1': `⇪ Caps Lock`,
's27056379e0acfdb0': `Palengvinti`,
's27076e66c5d483ba': `Vertikalus lyginimas`,
's2712dc5641a33226': `Paketų registrų paskyros skirtos kūrėjams ir leidžia konfigūruoti vieną ar daugiau
          registrų.`,
's27cc88818cc46ff6': `Stabilus`,
's281d957112b10f12': `Tiesiogiai redaguokite dokumento HTML`,
's28b6246ce616a548': `Įterpti lentelės stulpelių grupę`,
's29a1c26521879b9f': `Sumažinti mastą`,
's29acfd2778e8c377': `Paslėpti išplėstinį teksto formatavimą`,
's29b24c06315e9343': `Įterpti įvestį`,
's29eb103449472e3b': `Įterpti antraštę (3 lygis)`,
's29ee7434494a0dfe': `Įterpti antraštę (2 lygis)`,
's29f21c34494d614d': `Įterpti antraštę (1 lygis)`,
's29fbfc3449557f72': `Įterpti antraštę (6 lygis)`,
's29ff743449588131': `Įterpti antraštę (5 lygis)`,
's2a031834495bcdb4': `Įterpti antraštę (4 lygis)`,
's2a75c946ef4dcab7': `Įvairūs`,
's2b2ae20d26f78ac2': `Blokas`,
's2b8f50c64be440f7': str`Pasirinkite 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Užsisakykite`,
's2bad2d24def4aa0b': `Eilučių pertraukos (CJK kalba)`,
's2ceb11be2290bb1b': `Atšaukti`,
's2ced8e8fafb499f6': `Ištrinti elementą`,
's2d986d31f8d67357': `Lauko rinkinio įterpimas`,
's2d995a37cf5e4995': `Įterpkite "NoScript`,
's2de969afacdaa7a6': `Forma`,
's2df075aface0dab8': `Dalintis`,
's2e192b19ed15fcf6': `Puslapis`,
's2e39b99cf23606fa': `Nustatyti pasirinktų elementų išdėstymą`,
's2e4818861000b13f': `Maketavimas`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Perpildymas (y)`,
's2edd6688a65e21f0': `Perpildymas (x)`,
's2f0bcdffc92a786b': `Plūduriuojanti dešinė`,
's2f2044f2431a32d5': `Antraštė`,
's2f4d4bfbc466d91f': `Albanų kalba`,
's2f8da2cb5f236588': `Jūsų paketo pavadinimas. Turi būti apibrėžtas, pvz., \`@org/pkg\`. `,
's30cce87854901922': `Ikimokyklinio ugdymo įstaiga`,
's3124653c272f054c': `Stulpelio taisyklės spalva`,
's314a4f7685c8e824': `Visada`,
's31c06e226322f065': `Venkite našlaičių`,
's323dcde72b850272': `Vieša prieiga`,
's32911e52ee8ac745': `Įdėkite lizdą`,
's337a1e9022a8d19f': `Lentelė`,
's33c1450d2822bb0f': `Įterpti paveikslėlio antraštę`,
's33c18d5a4cbffa2a': `Airių`,
's33f85f24c0f5f008': `Išsaugoti`,
's342b0cabfa672822': `Padėkite naudotojui rasti valdiklį`,
's3437e0d9899e7ae1': `Siųsti telemetrinius duomenis apie "WebWriter" naudojimą.`,
's344ea8f4939cdc98': `Spalva`,
's34dcda3b0f9d5a98': `Perjungti url`,
's34f724979a124c50': `Nustato pasirinkto teksto fono spalvą`,
's355b21b89ce5d9c5': `Išsami informacija`,
's35ae5f4e0fa2777b': `Pasirinktinis derinimas`,
's35aeaff1425bca9e': `"WebWriter" nepalaiko medijos tipo `,
's35c3125c7750681e': `Blokinė citata`,
's3643189d1abbb7f4': `Kodas`,
's3649bacefe731bf6': `Įrankių dėžutės perjungimas`,
's365280e16a8ea32d': `Kopijuoti pasirinkimą`,
's366991b9c9287765': `Teisė`,
's36a194e38d653a26': `Duomenų anotacija`,
's36b3cefdcb897f15': `Perspektyva`,
's372fae706048ce41': `Netolygiai`,
's377e24af9628c37e': `Užsakytas sąrašas`,
's37a8c35f6581da5f': `Nėra inkaro`,
's37fa3b9cd51c2dfd': `Nustato pasirinkimo šrifto dydį`,
's380d17664bb69531': `Įterpti stulpelį prieš`,
's3815184eb09f0dcf': `Kursorius`,
's382a2aa3984474dd': `Sukurti`,
's38980f98cb07ceb8': `Išsaugoti aktyvųjį dokumentą kaip kopiją`,
's3914cb410fca44d4': `Importas`,
's3a179f6db2972384': `Rubino pozicija`,
's3a5ca02f282d247e': `Dalytis...`,
's3ae67088bbefba98': `Paketai`,
's3b0ab4b52326316f': `Šviesa`,
's3b3ea038c5d3bb06': `Skyrius`,
's3bdad99768e11911': `Tyrinėjamas`,
's3cb47df8290fa94c': `Įterpti parinktį`,
's3cf89cb47fdde7e9': `Nuoroda`,
's3d09398e555ee5f9': `Išplėstinės parinktys`,
's3d249bb480032121': `Sąrašas`,
's3d3efd1e19bdcfb4': `Datos ir laiko anotacija`,
's3d6a732c792ccb9e': `"Ruby" anotacija`,
's3d93f9ea0c5a13fa': `Vaizdas`,
's3d9548e211b958ce': `Praleisti sutapimus`,
's3e092e9d1ee2c5bb': `Klipas`,
's3e78ddc9a48a608d': `Gana`,
's3eb6d1e6e79ed7c4': `Dokumentų nerasta`,
's3eca5a034978754b': `Ištrinti pasirinkimą`,
's3f06e9abb6ebcb79': `Personažai`,
's3f1e7a3f2b283d3b': `Marža`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gudžarati`,
's3f7e097a9b2e6181': `Įterpti straipsnį`,
's3fd83566dd643d10': `Įterpti legendą`,
's3fe72792941c18f9': `Teksto apačia`,
's3ffcdc5db5e7d0c5': `Atvirkštinis`,
's40e3826b7f74a3b5': `Pan (dešinėje)`,
's40f07d7859284a44': `Dominuojanti bazinė linija`,
's4101ada154a1b958': `Vidurio`,
's410c465a5993f82d': `Linijos pertraukos galimybė`,
's41322d19c928c603': `IRT`,
's417b90913e05bc17': `Peržiūra`,
's418f2020fe996832': `Patvirtinkite pakeitimus`,
's41c724f0698148e9': `Pažymėti pasirinkimą kaip klaviatūros spartųjį klavišą`,
's41f65a763f8e44ab': `Lentelės antraštės grupė`,
's42721130228841b0': `Smūgio dėžutė`,
's429bd646f1cf8bc6': `Gramatikos LLM paskyros leidžia naudoti gramatikos LLM API teksto gramatikai taisyti.`,
's429dd933ba95549b': `Įterpti adresą`,
's42e470ef1d707a28': `Automatinis paleidimas`,
's42ffdab1291fb3de': `Įterpti eilutę po`,
's430831017f3f0499': `Poslinkis (y)`,
's430bd5017f42511c': `Kryptis (x)`,
's433ba70286202ceb': `Sulaužykite visus`,
's441b20a8a50e36b4': `Makedonijos`,
's445b8acb9206db6e': `Atmesti ir atšaukti`,
's446a924922651ea0': `Teksto pabrėžimas`,
's44cdba92713de38e': `Tinklelio plotas`,
's45518abd911471d0': `Kroatijos`,
's456a8d744313852a': `Erdvė aplink`,
's4634541f5056a546': `Abchazijos`,
's46d4abe6255cb9e1': `Iš naujo priskirti spartųjį klavišą`,
's4730c232e7209c40': `Apipjaustykite abu`,
's474f0eec369d02a4': `Išvesties pavyzdys`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Pažymėti pasirinkimą kaip datos ir laiko anotaciją`,
's47ebf3a8fb3b10c1': `Orientavimasis`,
's4802bb8eb52fbdeb': `Portalas`,
's4802e47fe2e95134': `Galimybė`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Teksto šešėlis`,
's4993444bfd3f3e5e': `Žlugti`,
's49ad24935b14e3df': `Kečua`,
's49c560aecfeb8c29': `Kaukė`,
's49dd67aed00029ef': `Matematika`,
's49e763aed00877a8': `Pagrindinis`,
's4a894f57eba1cf1e': `Spartusis klavišo klavišas`,
's4ac1ad6ecd6bd810': `Įvairūs leidiniai.`,
's4ad6e9d3c2365c98': `Kieta šviesa`,
's4b2c143acf931122': `Linijos aukštis`,
's4b58c01e2578f5e4': `Legenda`,
's4bbff4e008690da1': `Venkite puslapio`,
's4c1535f316305a2a': `Patikrinkite pasirinkimą`,
's4c402ff5355fd310': `Dvikryptis valdymas`,
's4caed5b7a7e5d89b': `Anglų kalba`,
's4cb38675a21b2c98': `Nepalaikomas savybės tipas '\${desc.type}' (apdorojama kaip JSON)`,
's4cc8391f172c0cdf': `Atleisti ekskursiją`,
's4d528b416ac8dee2': `Įterpti antraščių grupę`,
's4d546f6c87128d5b': `Pirmiausia erdvė`,
's4dcb9315f6527f9c': `Paleisti perkraunant`,
's4e191bdb4700a6e9': `Apversti (x)`,
's4e1c7fdb470386ac': `Slinkimas į kitą pusę (y)`,
's4e2562fe3990e621': `Klaida jungiantis`,
's4e361bf8eef3759a': `Žodžio pertrauka`,
's4ea0f21fc2a338a1': `Pereiti į aukštesnį lygį`,
's4eace13b3ed74187': `Šalutinis komentaras`,
's4efee5b48a4593cb': `Kilpa`,
's4f26e7cb7c0a8318': `Vektorinis piešimas`,
's4fd2e638aabb0bb3': `"WebWriter" palaiko daugelio skirtingų šaltinių įterpimą. Tiesiog įklijuokite
          nuorodą į turinį iš:`,
's4fda04cbc245e18b': `Alfa`,
's4ffac3fb33a2ee9b': `Tailando`,
's5015a8fb33b98872': `Plonas`,
's50489ffb1bde152e': `Įterpimas`,
's5068560b8d39663d': `Spustelėjamas žemėlapis`,
's517acbf1f96324f9': `Svoris`,
's523eb9043213ff0d': `Kursyvu`,
's52777d434baeed9b': `Įterpti pažangos indikatorių`,
's52af5d7ac34c2163': `Lentelės eilutė`,
's52e0bdc3ee304436': `Įdėkite skaitiklį`,
's531056f039febd39': `Įterpkite pasirinkimą`,
's536695196d0b6dc3': `Farerai`,
's542fcefa0bbaed86': `Atidarykite arba uždarykite įrankių dėžutę (tik siauruose ekranuose, kitu atveju įrankių dėžutė visada matoma šone).`,
's5432ad3c84273229': `Paveikslas`,
's543906d1db8b2283': `Redaguoti `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Kambodža`,
's54897f2764b0e4d0': `Įdiekite šį valdiklių paketą`,
's54cbfaf2a8da7818': `Paštu`,
's550839f3e4e205bb': `Pažymėkite pasirinkimą kaip labai svarbų`,
's55905c735052d295': `Teminė pertrauka`,
's5590dbf7e425789d': `Etiketė`,
's5623aa2f83b05c76': `Tibetiečių`,
's564d1648b1ceee9f': `Atnaujinta`,
's565cd5ffb0158c46': `Venkite regiono`,
's571a4f19e2f140c7': `Dėžutė (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Grįžti atgal`,
's5787c6d5b3b5541a': `Klipo kelias`,
's579c69f419b6caef': `Sklandus`,
's587ac858dd80f6fa': `Indeksas`,
's58bec0ecd4f3ccd4': `Griežtas`,
's59404f5593c32fdc': `Šrifto kerningas`,
's5941292bb77281ab': `Norvegų bokmål`,
's599dcd2472c75c19': `Pastraipa`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Pažymėkite pasirinkimą duomenų anotacija`,
's5a356677b61a6b7e': `Moldovos`,
's5b474b5c0ac0c7c4': `Lentelės stulpelių grupė`,
's5b517ac216f9ee62': `Į šoną`,
's5b8cc9bb61ddce15': `Įterpti pastraipą`,
's5bba2ac2e53bd1fd': `Kirgizų`,
's5be80ad6b8301710': `Inline startas`,
's5c1ecf88259b79f9': `Pristatymas`,
's5c2a1a52c0389c30': `Inžinerija`,
's5c63af7695445fcf': `Teksto stilius`,
's5d18ca4c3111be6f': `Įterpkite lentelės antraštę`,
's5d87c1e588f48d90': `Praktika`,
's5d929ff1619ac0c9': `Paieška`,
's5da52af9b083c29a': `Modelis`,
's5dc77784260a7236': `automatinis`,
's5e27738a2e8eb763': `Prisijunkite`,
's5e2cba97c0d971bd': `Pakuočių perkrovimas`,
's5e53415a6d5719ad': `Socialiniai mokslai`,
's5e6a7a0c30d2a270': `Praleisti sutapimus (automatinis)`,
's5e9e8e4d21bafedc': `Maisto produktų gamyba`,
's5ed03bb1f3a15949': `Paveikslėlis`,
's5f43af3669b1e098': `Šaltinis`,
's5feaf7fd7ee567c8': `Pertraukos žodis`,
's600fd23c9ce971e8': `Spausdinti aktyvųjį dokumentą`,
's602bbd28dae2c60f': `Savarankiškas paleidimas`,
's60ff598dfcf2c773': `Pagal teisę`,
's61053f0e3ebbd272': `normalus`,
's613c6ff83883c04f': `Lentelės stulpelis`,
's6196153c4b0c1ea0': `Įdiekite`,
's61c017f6d5c303af': `Fryzų kalba`,
's61ded17ca3f48c82': `Pabraukimo poslinkis`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Kopijuoti pasirinkimą`,
's624e31cd4f1b89d4': `Sklandus slinkimas`,
's626daf42b1ab7df7': `Lygiuoti į kairę`,
's6280bf993915c57a': `Slinkimo marža`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Aprašymas`,
's63dfc5b1c1c27849': `Jidiš`,
's63e03c70f67ebf9c': `Kontekstas`,
's63e71d20d1eaca93': `Vokiečių kalba`,
's640bc7710d0143ce': `Aktyviajame dokumente iš naujo atlikti paskutinį neatliktą pakeitimą`,
's64dc1fc7e3db45c9': `Sukurti naują dokumentą`,
's65ac276544ba33cd': `SVG failas`,
's66765c420ee578e4': `Tolygiai erdvėje`,
's669b18c6d2d9c95b': `Nėra`,
's6747dbf4ad6063ba': `Savarankiškai baigti`,
's6787497df07fa97e': `Gali slinkti per stoteles`,
's67c2b60a506a09e4': `Vidurinis leidimas.`,
's680bd4d926cd5a84': `Išsaugoti 3D`,
's6827930ef1aeaf99': `Bazinis URL adresas`,
's684a16f3c711394d': `Per dešinę`,
's687e27f036a71b32': `Izoliuoti`,
's68b87d7b61052dc3': `Lentelės eilutė`,
's68e0e3a2bab7ce3e': `Venkite`,
's690da6b432987c6f': `Automatiškai sukurkite atsarginę dabartinio dokumento pakeitimų kopiją. Pakeitimai atkuriami, kai iš naujo įkeliamas "WebWriter".`,
's69311c4e25074fb3': `Vidurinė mokykla`,
's697400b541fbc3cd': `Pagal`,
's6988ab5d47593a26': `Turite naujausią "WebWriter" versiją.`,
's69a49786a8009f43': `Raskite paketus...`,
's69b12144dbb6544d': `Laosas`,
's69d88ef4b2618980': `Viršelis`,
's69fbbdb8ad2a084a': `Patamsinti`,
's6a31eff1ec4f71ad': `Paslėpti užpakalinį veidą (3D)`,
's6ac62e1c8c66f3bb': `Kompaktiškas superscr.`,
's6b585ba37cdb8260': `Paveldėti`,
's6b61f8abf89586be': `Hebrajų kalba`,
's6bd7a02fdf93e653': `Suderinkite turinį`,
's6cfc66b824ea05ba': `Trapūs kraštai`,
's6d02dc19e21eb49c': `Viršuje`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Vietnamiečių`,
's6d8b3b8047ed378d': `Maišymo režimas`,
's6d8c02aee480af7a': `Meniu`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Įterpti stilių`,
's6e288a119281f4c2': `Teksto atvaizdavimas`,
's6e4c20c6debcd5ca': `Pasirinktinis pateisinti`,
's6f84199e62584905': `Iš anksto suformatuotas tekstas`,
's6fb3053e7244d326': `Kitos sritys`,
's70178e04a3b691b6': `Atidaryti nustatymus`,
's7031ca562378bde6': `Geometrinis tikslumas`,
's7060970b5ed20a58': `Interaktyvumas`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `"WebWriter Cloud`,
's71a0549fd71219c9': `Rodyti nestabilius paketus`,
's71dec51005acc1e4': `Tanki eilutė`,
's72f2a02e2a5a4ee3': `Žiniasklaida`,
's730182ad28374cda': `Objektas`,
's731678e227a20559': `Šis įrenginys`,
's736904f276fbd441': `Gamtos mokslai`,
's739544d0c858c633': str`Arba atsisakykite 
          ${0} čia 
        `,
's73cb20c838e761e1': `Pjūvio pasirinkimas`,
's7417792bbe720149': `Redo`,
's741fae02b3dd24f3': `Pikselinis`,
's743f778233e42a3f': `Įterpkite pastabą`,
's744d993d03f29851': `Ekranas`,
's748c0074eff45884': `Manipuliavimas`,
's74aa0039a87141e2': `Elipsė`,
's74b9781bacfcc87c': `Pandžabo`,
's74cd20a7aece9b91': `Užpildymo langelis`,
's75109f5307578a61': `Sveiki atvykę į "WebWriter`,
's75a27f43413e02c5': `Prancūzų kalba`,
's75d83fc3f0cfab40': `Antraštė`,
's762e5704cc84089d': `Nustatyti kitas pasirinktų elementų stiliaus parinktis`,
's77318393dfdb0775': `Pašalinti eilutę`,
's77e594ddcc10c774': `Leisti naudoti komerciniais tikslais?`,
's782eac2b3e80323d': `Pažymėti pasirinkimą kaip pabrėžtą`,
's782f286a79cca35d': `Santykinis`,
's78673a3539cb1915': `Viršuje kairėje`,
's78789724e789221c': `Dydis`,
's789ff24c8f03f1a4': `Tarpai tarp raidžių`,
's7995733bf97c01cc': `Serbų-kroatų kalba`,
's7a99528e7b64635a': `Occitan`,
's7aaf0c06e69600f1': `Klaida su `,
's7ae49e142487766c': `Bendrijos prieiga`,
's7af555180b30a947': `Atidarykite kūrėjo įrankius`,
's7b4ba250601b8667': `Įterpti šabloną`,
's7b560d8693ed8f42': `Stacionarus`,
's7b9994904c4f5b54': `Tadžikų`,
's7bdf0fd5b014d36c': `Didelė svarba`,
's7beb1e77e82363eb': `Atšaukti paskutinį aktyviojo dokumento pakeitimą`,
's7c61118554a0ec36': `Didžiausias (x)`,
's7c95876637f6a9d7': `Filtras`,
's7cb4e55c59663b1c': `Įmonė`,
's7cfe12cd14df9950': `Pasirašyti`,
's7d27db3c9639c6dd': `Pakaitinis`,
's7d8103f6f06f83d6': `Paminkštinimas`,
's7d864465dddbb50d': `Leisti keisti dydį`,
's7de0e28d6c309a4e': `Leisti atlikti lietimo veiksmus`,
's7dea785045c3cc74': `Paspauskite naują klavišų kombinaciją...`,
's7e0b179d4d1414eb': `Įveskite nuorodą`,
's7e6570f2f1ae320f': `Sintezuoti šriftus`,
's7ecb1f29332293e5': `Derinimo atskaitos taškas`,
's7ed13ccddb1bf3c3': `Perdangos`,
's7edbe0b213199995': `Bakalauro laipsnis`,
's7ede1c55e35ce9d6': `Modeliavimas`,
's7f09197a4814079b': `Nustatyti pasirinktų elementų interaktyvumo parinktis`,
's7f326a142e856656': `Stilius`,
's7fcb35d23be1e643': `Laukų rinkinys`,
's80570196a9ce6d11': `Įjungti telemetriją`,
's806f84eb0ace116e': `Peržiūrėkite, ką pasirinkote, ir pakeiskite. Kopijuokite, iškirpkite, įklijuokite, prisekite arba pakeiskite išdėstymą. Siūlomos skirtingos parinktys, priklausomai nuo jūsų pasirinkimo, t. y. teksto formatavimas.`,
's80a42b81c52d4d8f': `Priežiūros spalva`,
's80b71fc6f43c5ce1': `Palaidas`,
's812cbda653daaeba': `Ši funkcija dar neįgyvendinta`,
's814d528c8af55807': `Apibrėžčių sąrašo elementas`,
's81c3d8809658b951': `Kašmyras`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Tęsti`,
's8247d32213e35f24': `Įterpkite pagrindinį`,
's82665b2ffabc9c0a': `Svetainė`,
's828b1ecea8715884': `Dėžutė (kairėje)`,
's833bd0422a7ef95d': `Skirtuko dydis`,
's83420ad7b6a14db5': `Perjungti Dev įrankiai`,
's83c15613b6f6f3c8': `Tik internetu`,
's83cd32b685ccc9b7': `Valdikliai`,
's83f26d02dd7aa681': `Matomas`,
's840fa49e8989c028': `Padėtis / forma`,
's844a76d1843ceb3c': `Iš naujo nustatyti numatytuosius nustatymus`,
's84e4e8ae645b82ac': `Viršutinė dešinė (y)`,
's84e9c7f8785ca60b': `Įterpti formą`,
's8517ae4da104b004': `Lentelės stulpelių grupė`,
's85186a61e0d55bac': `Vaizdo įrašas`,
's851a7deea5984646': `Licencija kaip Creative Commons OER?`,
's85f9aa6d3ea0e421': `Lentelės poraštės grupė`,
's864b0e6270e97246': `Pažymėti pasirinkimą kaip šalutinį komentarą`,
's8670e5ad3bf0dcf8': `Išsaugoti kaip`,
's8688d74dd3716d6e': `Komandų klaviatūros spartieji klavišai`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Formos marža`,
's87cefc710b3567fb': `Sudėtis`,
's88676f992b2965db': `Ištempkite langelio turinį`,
's886897f2fd4edb99': `Paslėptas`,
's886c5db2a5579873': `Koncepcija`,
's888c71e8fcb916d3': `Automatinis išsaugojimas`,
's88a62d29529948fb': `Įterpti lentelę`,
's89950d86c8004d4b': `Nepraleisti jokių sutapimų`,
's89bca7498f20e041': `Fono klipas`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Pertrauka prieš`,
's8a4ff2bd9c13498c': `Įrašas`,
's8a6585c48ea104e9': `Paslėpti tuščias ląsteles`,
's8a9eb438abac7c6a': `Etiketės`,
's8b0432eecbd8b034': `Atnaujinti`,
's8b7580c35e2aef87': `Viršuje kairėje (y)`,
's8bc4affa761aa8a2': `Įterpti paveikslėlį`,
's8c7f51cb067644c7': `Duomenų sąrašas`,
's8d342ecaa9e75b9b': `Santykiai`,
's8d797888455f4147': `Pertraukų erdvės`,
's8d83386457e91813': `Atšaukite / pakartokite pakeitimus arba peržiūrėkite juos iš besimokančiojo perspektyvos.`,
's8d8643013a7754d1': `Sulygiuoti tekstą`,
's8df30fe2a50d3479': `Įterpti eilutės pertraukos galimybę`,
's8e715248c3a78446': `Iškirpti atranką`,
's8f29e48d6b9a1aa8': `Lentelės antraštės eilutės įterpimas`,
's8f4be9f086eb530f': `Panaikinti`,
's8f533296a536965e': `Išsaugoti kaip...`,
's8fad58c831ecf017': `"Ruby" teksto talpykla`,
's8ffe7abcbed8eb43': `Vertikaliai, iš kairės į dešinę`,
's90105521fcc40453': `"WebWriter Cloud" paskyrose galite saugoti dokumentus internete ir dalytis jais su
          mokiniais. Pridėkite paskyrą čia ir ji bus prieinama kaip vieta dokumentams išsaugoti,
          įkelti, bendrinti ir atidaryti.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Šriftų paletė`,
's90f7c1cf501ea0a7': `Spalva Dodge`,
's91093e0b087911ba': `Pabrėžtina pozicija`,
's919e1724f589c9b1': `Lizdas`,
's91c5ed7769d00b65': `Įterpti įterpti`,
's9219acd5bef6269e': `Po kairiąja puse`,
's92548405912d46bf': `Slinkimo momentinis sulygiavimas (y)`,
's9258280591309342': `Slinkimo momentinis išlyginimas (x)`,
's927d796559f49439': `Pagrindinė informacija Kilmė`,
's92b177e579ef7b97': `Akcentas`,
's92f846b9be2e8e8d': `Pažymėti pasirinkimą kaip pasvirąjį`,
's93566b84230af4f5': `Įterpti paveikslėlį`,
's936aa0b239679585': `Įterpkite teminę pertrauką (paprastai rodoma kaip horizontali linija).`,
's9370dc6afa716b57': `Pasienis`,
's93f083e654a45715': `Bretonai`,
's94653c76b2d86a04': `Apibrėžtas terminas`,
's9485af2e7cd9418f': `Pradinė mokykla`,
's94d2eee44b292567': `Išplėstinių parinkčių perjungimas`,
's94d61907ee22a8c1': `Korėjiečių kalba`,
's94eb1effbbb6498b': `Perpildymas`,
's951aa3a6439f1271': `Sąrašo žymeklis`,
's9565553d163fc92a': `Skriptas`,
's957787fc6b7ea5c0': `Keptuvė (aukštyn)`,
's95c161f68e5180a5': `Patikrinkite pasirinkimą`,
's95d56e58f816d211': `Olandų kalba`,
's95d8e41a64635c7c': `Baltoji erdvė`,
's95de7e1eff6c053e': `Horizontaliai, iš viršaus į apačią`,
's960d3a90ac199368': `Retų-romėnų kalba`,
's96532132a29dd542': `Įterpti garso įrašą`,
's96a045dcade75ad0': `Tankus stulpelis`,
's9781a5bb3fcb26a3': `Pirmiausia pasirinkite įmonę`,
's978522fbc9577a7e': `Somalio`,
's97881699a2b21d5b': `Eilutės tarpas`,
's97aa76056a81bd36': `Metrikos`,
's986facb3ecc9602c': `Į šoną, iš dešinės į kairę`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Išorinis failas`,
's98977a87d1b93941': `Informacijos, stilių ir scenarijų atstatymas`,
's990d0e0fa2ab00b5': `Galisija`,
's99229574e5692f19': `Grenlandijos`,
's99a990f3841ad283': `Failai `,
's99b38e000175cc84': `Perbrauktas`,
's99f110d27e30b289': `Pavadinimas`,
's9ab10fbf4c7a7322': `Pabraukimo padėtis`,
's9abadcc828884d7b': `Teksto sritis`,
's9b7cd8860c8fc922': str`
          ${0}
          bus perrašytas. Ar esate tikri? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Fono spalva`,
's9c8df9626d152d5a': `Apibrėžčių sąrašo terminas`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Lentelės stulpelis`,
's9cf68f87b8e6122f': `Azerbaidžanas`,
's9d167ef77aed79b6': `Sluoksnis`,
's9d2d00982edafabb': `Turkijos`,
's9d430adc5be110e9': `Atvirkštinė eilutė`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Pašalinimas`,
's9df571714a1efb44': `Yra automatiškai išsaugota šios tyrinėjamos užduoties versija. Įkelti ją?`,
's9e28faa598332e2b': `Įterpti vaizdo įrašą`,
's9e3dbb678150edd4': `Nustatyti šrifto šeimą`,
's9e40e59654c8ad67': `Stulpelis`,
's9e85800d3700e31c': `Trasa`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Šrifto variantas`,
's9f1ecdb3061d9cbc': `Išsaugoti erdves`,
's9faf26107ed49fb9': `Lentelės ląstelės įterpimas`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Perėjimas`,
's9ff3121d30f88d52': `Normalus`,
's9ffe1bbe64712bf1': `Drobė`,
'sa00df4e39c72d3b4': str`
          ${0} nepalaikomas 
        `,
'sa013e119fec906fb': `Eilutė`,
'sa01e7bf33563ef72': `Pagrindiniai duomenys Priedas`,
'sa126cf8c627cec1e': `Vaizdo atvaizdavimas`,
'sa13f72278add7513': `Pagal teisę`,
'sa1647e3b36ec08d7': `Derinkite vertikaliai`,
'sa172190ea21f9b1c': `Prisijunkite prie nustatymų, atidarykite tyrinėjamąjį objektą arba sukurkite naują.`,
'sa1c6c459b9b5115c': `Absoliutus`,
'sa2cba871f6cdd99f': `Asamių kalba`,
'sa2eff4dad1c119f1': `Tinklelio šablonas`,
'sa30c12014e955946': `Rusų kalba`,
'sa30f1981fd1cd441': `Šrifto dydis`,
'sa311a24c1471a974': `Dokumentas`,
'sa352d168b262aa06': `Įterpti poraštę`,
'sa37fee6a52d18063': `Ištrinti dokumentą`,
'sa39c7ac1d37f3bce': `Pažymėti pasirinkimą kaip "dvikryptį izoliuotą".`,
'sa3b4c01623211544': `Jėga`,
'sa40fd43756fa8913': `Persų kalba`,
'sa417644bef21a9aa': `Neįvardyta tema`,
'sa43800e28be1bdbc': `Apdailos spalva`,
'sa477cb1825dceb3b': `Sudanas`,
'sa492a51a707930fa': `Įterpti blokinę citatą`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Antraštė apačioje`,
'sa50d3c35533f1d99': `Visi laukai`,
'sa53c5cb03a8fda50': `Prisegti pasirinkimą kaip fragmentą paletėje`,
'sa557ae6bee9148a6': `Pažanga`,
'sa589e1df65dde0ec': `Nustatykite pasirinktų elementų dydį, užpildą ir paraštes`,
'sa5c371b4bb75e590': `Kairėje pusėje`,
'sa5c80e623459ffe4': `Įterpti antraštę`,
'sa5df1bcdba46c3fb': `Paveikslėlio antraštė`,
'sa602e3fd3f2d98fd': `Animacija`,
'sa644d580d8a11e60': `"Ruby" derinimas`,
'sa645d315510dc09e': `Pasirinkite kelią iš disko`,
'sa65d4ad99f1d8c06': `Nustatyti teksto foną`,
'sa6607436f60ccc1a': `Estų kalba`,
'sa6f8d27bca557059': `Perkelti meta / nuorodų / stiliaus elementus aukštyn / žemyn į šį elementą`,
'sa757645ad842da97': `Išsaugoti pertraukas`,
'sa75b95980cd80e78': `Redaktorius`,
'sa7698b3d20a6d1ec': `Slinkti`,
'sa778acc33947c7b8': `Baigti kelionę`,
'sa78a67272a4a6f95': `Matematinė formulė`,
'sa79167651dce1e80': `Alternatyvus tekstas`,
'sa7af797a46c7d09a': `Lentelės poraštė`,
'sa7dbe35b758c138d': `Įterpti drobę`,
'sa7dc6b8ef3f595dc': `Įterpti šaltinį`,
'sa8279f8211b3950d': `Išsaugoti pertraukas ir erdves`,
'sa8b55cab62e439b5': `Pašalinti stulpelį`,
'sa8bbe0197d31b423': `Trumpas aprašymas`,
'sa9ff3b762365abe6': `Transformacijos pradžia (z)`,
'saa02e3762368ff35': `Transformacijos pradžia (y)`,
'saa065776236bfa28': `Transformacijos pradžia (x)`,
'saa33768e03c45fc8': `Failo dydis`,
'saaad98061a20ac39': `Įterpkite matematinę formulę`,
'saab875d8cfcfe712': `Tema`,
'saad4380b9cc6cefd': `Pakaitinis per`,
'saaec15c97a9e4245': `Atvirkštinis stulpelis`,
'sab0c57df694a0a09': `Trim startas`,
'sab4d9283896d9422': `Snap raiškos pikseliai`,
'sab55faae8e165407': `Padding&lt;br&gt; kaip tarpas`,
'sab5e7d2a069a2951': `Profesinis pažymėjimas.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Sulygiuoti į dešinę`,
'sac895c732f350ac5': `Tamsus`,
'saced41ddda8b2354': `Lankstus pagrindas`,
'sad190f86451081c0': `Nepalo`,
'sad6be321164d08c8': `Kompaktiška matematika`,
'sadd352cc7f6f2307': `Šalia`,
'sae098810f946ca7c': `Tagalų kalba`,
'sae185e6af80ec81e': `Švedų kalba`,
'sae1c7f13b7c0c47f': `Pradžia`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maoriai`,
'sae9d739068eee2c5': `Totorių`,
'saf312eaeec77a802': `Įtraukti aprašymo sąrašą (žodynėlį, terminų sąrašą)`,
'saf3da7c95cb17260': `Pažymėkite pasirinkimą kaip viršutinį indeksą`,
'saf440a0a592f2835': `Atnaujinti iki`,
'saf9e5134ba1a7d30': `Slinkti snap`,
'safc6f203342d09e2': `Perjungia aktyviojo dokumento peržiūrą`,
'sb0a7e3adf4a125ee': `Viršutinė dešinė`,
'sb0a974028c99ca6d': `Leisti pritaikyti?`,
'sb0d4f0f7993cf085': `Nustatyti šrifto dydį`,
'sb0f3327210fe18fc': `Stulpeliai`,
'sb0f93c1c60c0249a': `Rubino pagrindas`,
'sb1494c08c8c720d1': `Nustatyti teksto spalvą`,
'sb19611adbc88f711': `Išplėstinis: rodyti šaltinio redagavimo komandas, pvz., parodyti dokumento HTML arba pridėti pasirinktinius stilius ir skriptus.`,
'sb206d700d26b14ff': `Pabraukti`,
'sb233557012dcb328': `Perkelkite žemyn`,
'sb26035b596566abf': `Neįvardyta`,
'sb2cda80610c8d6ea': `Erdvė visi`,
'sb2dc787b0983ebc6': `Lietuvių kalba`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Centras`,
'sb3ba3276ae93627c': `Įterpti iš anksto suformatuotą teksto bloką`,
'sb430f5b4824de0d3': `Pasirinkite išdėstymą`,
'sb43db07b24da018a': `Amharų kalba`,
'sb45f9fb4dba6e71a': `Nenustatytas`,
'sb4e003a459464d85': `Kurdų`,
'sb4f0310e6787d098': `Uzbekų`,
'sb4f1dffbb6be6302': `Skaidrus`,
'sb51270e19988f9bd': `Regionas`,
'sb59d621e3c93cc27': `Bendros ląstelių ribos`,
'sb5e9e1776242b028': `Sąveika`,
'sb60bc1250aad44c1': `Spanas`,
'sb60dd9d23d31ee66': `Daktaro laipsnis`,
'sb6103872073d369e': `Įterpti informaciją`,
'sb616811735bfbafd': `Lentelės langelis`,
'sb628960829e223bb': `Praleisti visus sutapimus`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Taikyti ir importuoti`,
'sb66e2181a7b5738a': `Įjungdami telemetriją, leidžiate rinkti ir saugoti duomenis pagal mūsų`,
'sb67e0e7c0869f982': `Skirtumas`,
'sb68e83cda6c85af8': `Lentelės antraštė`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Apdailos storis`,
'sb70c17f7899f9b01': `Lotynų kalba`,
'sb71941f552f3504d': `Nustatyti specialią vertę`,
'sb740eab4afd5a710': `Tinklelio automatinis srautas`,
'sb741b6e0ca589122': `Grįžtamasis sluoksnis`,
'sb7c77d0415de05cf': `Atlikti testus`,
'sb7fb7568f6883ab8': `Bendrinti aktyvųjį dokumentą`,
'sb85774dc5d18ff0f': `Patvirtinkite`,
'sb85b1e36579852a6': `Neteisingas el. pašto adresas arba slaptažodis`,
'sb884fa76bfc55429': `Arabų kalba`,
'sb8a3d4df7d1c5e6b': `Balansas`,
'sb8f610a0e8df91fc': `Šviesumas`,
'sb8f855b49234b81b': `Taikyti`,
'sb905da066c10182c': `Be to, tamsesnis`,
'sb940ade1bd81be7e': `Po kairiąja puse`,
'sb9e9a7dd45966756': `Pažymėkite pasirinkimą kaip paryškintą`,
'sba509fd8ed61d1d5': `Neišsaugotas failas`,
'sba64d8954d027206': `Nepermatomumas`,
'sba88d90cd6c751b3': `Stulpelio taisyklė`,
'sbaf0a7c417e388af': `Sveikata`,
'sbb15d427ee1aa676': `Tigriniečių kalba`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Foninis filtras`,
'sbb85a407d730e13d': `Įterpti paiešką`,
'sbb86c6c96f598bb8': `Mišrus`,
'sbba0156f795d8c07': `Redaguoti pasirinkimą`,
'sbba865d4b437944f': `Atributas`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Pašalinti`,
'sbc5f2a81604baf9b': `6 antraštė`,
'sbc5f2b81604bb14e': `5 antraštė`,
'sbc5f2c81604bb301': `4 antraštė`,
'sbc5f2d81604bb4b4': `3 antraštė`,
'sbc5f2e81604bb667': `2 antraštė`,
'sbc6953a36ced943f': `privatumo politika`,
'sbd181cd54b8402a4': `Redaguoti pasirinkimą`,
'sbd35ee879d9cf770': `Rubino tekstas`,
'sbd40f40cbadd38d5': `Pašalinti šį valdiklių paketą`,
'sbd72dc858de95ce8': `Birmos`,
'sbe3c60c65f129daa': `Humanitariniai mokslai`,
'sbe4a7c8f231739b3': `arba įklijuokite / numeskite / pasirinkite failą`,
'sbe90de083557ef3e': `Svahilių kalba`,
'sbefb6064cba01844': `Įterpti eilutės pertrauką`,
'sbf00e1ee999ea94e': `Įterpti scenarijų`,
'sbf519920c2017d67': `Pakabinamas`,
'sbfa01f189a68d3e9': `Lankstus augimas`,
'sbff54e740c4086eb': `Rodyti nežinomus paketus`,
'sbfff51feacf30196': `Sanskritas`,
'sc0ceaa9843510f67': `Turkmėnų`,
'sc1611c0558728a2a': `Pozicija`,
'sc1a155cc25899250': `Lentelės eilučių grupė`,
'sc1aa1f6051b7102a': `Rumunijos`,
'sc1edebeaef92b7bd': `Fiksuotas lentelės išdėstymas`,
'sc1fff4f356dfb2fb': `Transformuoti`,
'sc24bda3c061fddf8': `Paspaudžiama sritis`,
'sc252a4e091763606': `Įterpti lentelės poraštę`,
'sc2536e077514accc': `Slinkimas`,
'sc275dd00036d16cb': `Citatų pobūdis`,
'sc28864200d2a3799': `Nukopijuokite QR kodą kaip paveikslėlį`,
'sc2a24a9dd41a9503': `Apdailos linija`,
'sc2b734cca2fa643b': `Pan (žemyn)`,
'sc2e2a0dbf03723b7': `Išplėstinis: Paketų tvarkyklėje rodyti paketus iš nežinomų šaltinių (Įspėjimas: gali būti nesaugu)`,
'sc3998b77d72c2932': `Įterpkite svetainę (kaip įterptinį rėmelį)`,
'sc3ac225273c8316b': `Bendra`,
'sc3cfee84dbbf36ae': `Vietinis failas`,
'sc3f09a9b6fa4fbed': `Viduje`,
'sc43767deea72e9f3': `Aprašymo sąrašas`,
'sc462bbdd36bcba6b': `Nuorodos langelis`,
'sc4ee3e4ee994dafd': `Ukrainiečių`,
'sc50d09edf9325339': `Dialogas`,
'sc52b67794c06a0d3': `Perspektyvos pradžia (y)`,
'sc52e8b794c0913d6': `Perspektyvos pradžia (x)`,
'sc53de149fcaad713': `Tarpžymeninis`,
'sc546f489f9c0cced': `Perjungia aktyvaus dokumento bandymo režimą`,
'sc5bcf50d1b578d9f': `Šrifto funkcijos nustatymai`,
'sc5cb39478b9b7625': `Pažymėti pasirinkimą kaip indeksą`,
'sc6415b50ff928294': `Sąrašo elementas`,
'sc650ff15b20fe9d3': `Pasukimas (z)`,
'sc6578b15b2154365': `Pasukimas (x)`,
'sc65aff15b2183e58': `Pasukimas (y)`,
'sc6da0f4a7e4d710e': `Šrifto kalbos pakeitimas`,
'sc74e3567875ce255': `ir valdiklio žyma, ir NPM paketo pavadinimas`,
'sc7eb080b96e244df': `Malajų kalba`,
'sc8ac7ef92b95df3f': `Perkelti (x)`,
'sc8af536e2084ade0': `Paletė`,
'sc8b022f92b992bc2': `Perkelti (y)`,
'sc8b39af92b9c2d81': `Perkelti (z)`,
'sc8d2c7f6c33a2b32': `Nustatyti pasirinktų elementų teksto stilių (lygiuotę, įtrauką, tarpus ir t. t.)`,
'sc8fa0e3de389ef1c': `Šrifto dydžio reguliavimas`,
'sc9474bf7a0668d73': `Santrauka`,
'sc94e314312a8900c': `Čekijos`,
'sc980855a000b76ea': `Dugnas`,
'sc98b103772de63f4': `Suomijos`,
'sca7cfe2bef51b2a5': `Šaknis`,
'sca7fed2bef53cb99': `Vaidmuo`,
'scabe6ecee5e01fd2': `Maltiečių`,
'scace301a88231cce': `Įterpti`,
'scbc55f622ec078c1': `Peržiūrėti langelį`,
'scbe537fc38ff4c13': `Tinklelio automatiniai stulpeliai`,
'scc1db59d292cbc4c': `Skyrius`,
'scc56b218a2689c42': `Armėnų`,
'scc5ba32e0de06744': `Sesoto`,
'scd15088c39fe9edf': `Langelis "Padding Box`,
'scd9cedeb5ece3adb': `Prielinksnis`,
'scdf536b65be39ec5': ` Sukurti / importuoti`,
'sce8a4e3f7c98482d': `Sisvati`,
'scec2be75ee985f6c': `Ideografinis`,
'sceecdd0bb404bc17': `Įterpti parinkčių grupę`,
'scf00d48fd5953a03': `Graikų kalba`,
'scf932840a69dbb7c': `Portugalų kalba`,
'scf932a8577057752': `Kojinė`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Apačioje dešinėje`,
'sd01178c54f648118': `Balanso stulpeliai`,
'sd03bff50f87f82d4': `Brūkšninis simbolis`,
'sd05a155fe09c2866': `Prisijungę, kai naudojate`,
'sd0864ea6cb6ef22e': `Bendruomenė`,
'sd10fdbe6caf9a998': `Linijos pertrauka`,
'sd121d3b959b7888d': `Optimizuoti greitį`,
'sd1a78e667a1a139f': `Pažymėti pasirinkimą kaip įterpimą`,
'sd1cffad290ea5b3b': `Laikykite visus`,
'sd1f10284eeb17b25': `Fidžis`,
'sd1f44f1a8bc20e67': `El. paštas`,
'sd1f81984eeb7c0e8': `Užpildykite`,
'sd29dc07235eea0f5': `Citata`,
'sd2addf69477cd4b4': `Importo paketas`,
'sd2ed26defc646d47': `Foninis filtras`,
'sd2ef82b8ea877c6d': `Afrikiečių kalba`,
'sd319aae1401f1e19': `Fiksuota`,
'sd3a288c1094b8a63': `Stulpelio taisyklės plotis`,
'sd3c65ef5c380c046': `Įdėklas`,
'sd3dcb76f7b28adb8': `Latvijos`,
'sd3eca1e0f4209f6e': `Apipjaustykite visus`,
'sd3f402df8619ddcd': `Ši informacija apie jus automatiškai įtraukiama į naujus dokumentus. Metaduomenų
          redaktoriuje ją galite pakeisti kiekvienam dokumentui.`,
'sd4368b12645d3c0f': `Įterpti portalą`,
'sd452cebf4a0313d1': `Rodyti šaltinio redagavimo komandas`,
'sd48cc52117f4d68b': `Italų kalba`,
'sd52660ee947ca58b': `Lentelės stulpelio įterpimas`,
'sd588d17a1b25c220': `Teksto perpildymas`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Aukštasis išsilavinimas.`,
'sd5cf95145e4d89ca': `Atsegti šią ištrauką`,
'sd5fd9d11a92f5b1d': `Apačioje kairėje (y)`,
'sd60c9bbc51375635': `Įterpti mygtuką`,
'sd66c4767fa3dde28': `Akcento spalva`,
'sd679c8b1bf8cc8a5': `Mažos kapitalizacijos`,
'sd7086c4425c53c80': `Šriftų šeima`,
'sd837f42ac7cbfb58': `Forma (išorėje)`,
'sd88076d2994ee0fb': `Išimtis`,
'sd89a2e529b31ef43': `Atšaukti`,
'sd8a345e95668b73b': `Vertikalus, iš dešinės į kairę`,
'sd8ce9e57270b030d': `Šrifto ruožas`,
'sd8ecf227c7c49331': `Matematinis`,
'sd8f923198e0c5c6a': `Pabaiga`,
'sd9c21e5f60d6bdd8': `Danų`,
'sd9ff8e2612e63d50': `Pasienio langelio dydžio nustatymas`,
'sda2d76b976502a8d': `Atviras...`,
'sda344aacb837387e': `Padėtis konteineryje`,
'sda5b6fa8b771f996': `Plaukti į kairę`,
'sda9254d1f1228e1a': `Vengrų`,
'sdb1595f5c742dfbb': `Įvestis`,
'sdb711380a28fec75': `Įterpti sąrašą (sutvarkytą)`,
'sdb73788b3c975f16': `Automatinis`,
'sdbee7e0523a23a42': `Dešinėje apačioje (y)`,
'sdc48456f9a27ae02': `Generatorius`,
'sdc70d81cf6c28533': `Gruzinų kalba`,
'sdd1ff479d04ac140': `Viešoji svetainė`,
'sdd2fc8919a9c3111': `Fono suliejimo režimas`,
'sdd35b688281b6dea': `Japonų`,
'sddc49047f66a64ab': `Aprašymas nepateiktas`,
'sdef34fe08bb28b09': `Kinų kalba (supaprastinta)`,
'sdf62e305e1594805': `Pažymėkite pasirinkimą ruby anotacija`,
'sdf946172dfa0328f': `Viršutiniai indeksai`,
'sdf9bc5d9b7f3e3de': `Suderinimas`,
'se036b53f145441cd': `Mišrus turinys`,
'se06f459fccdc3ce9': `Sulygiuoti paskutinę teksto eilutę`,
'se0a782a8be8e018b': `Norvegijos`,
'se0cda6b80a1bb50f': `Slovakų`,
'se0f67eae944f8f94': `Nutildyti`,
'se1312d6528f9a259': `Joruba`,
'se16c5e66886fbc59': `Straipsnis`,
'se1f5bb0386c88f96': `Nustato pasirinkto teksto spalvą`,
'se219da7b1e955c65': `Aiškus formatavimas`,
'se25e4f2cb77b8be8': `"WebWriter" sąsajos kalba ir nauji dokumentai`,
'se2796c5824ec8916': `Turinio matomumas`,
'se308836a594808b6': `Singhalese`,
'se36c5b1baf5e0660': `Bet kur`,
'se39c065efa467782': `Baskų kalba`,
'se3b4c857f91f80d7': `Spartieji klaviatūros klavišai`,
'se47baf2fd16b9d2b': `Šablonas`,
'se48bd9e6c2a3109d': `Sąskaitos`,
'se58467472725ad0c': `Vaizdo skiriamoji geba`,
'se58f06c2b0583ff7': `Pasirinkite koordinates`,
'se5dc1e97fb743ade': `Tarpai`,
'se619a501d1bfe6a5': `Apvyniokite`,
'se62385ac082368d2': `Pažymėkite pasirinkimą kaip citavimo šaltinį`,
'se6297163cac9d276': `Redaguoti šaltinį`,
'se633223a0b88625e': `Ląstelių išdėstymas`,
'se638417c560cfe5c': `Įsilaužimas į vidų`,
'se64f418b4e733b6c': `Įterpti išvestį`,
'se6cdad455e2d8c02': `Įterpkite padalijimą`,
'se79c0a3ac70d8fb3': `Asp. santykis (x)`,
'se79fae3ac710dc36': `Asp. santykis (y)`,
'se7fad370d8fb4cec': `Optimizuoti įskaitomumą`,
'se8a94b4effa2033e': `Abėcėlinis`,
'se95d4e55ea186d9a': `Slinkiklio spalva`,
'se96d43a515b8451c': `Slovėnijos`,
'se96fd76ba1b2975a': `Centrinė`,
'se9ac05f36b004eb0': `Paslėpti įvadinę ekskursiją. Išjungti, kad ekskursija vėl būtų rodoma.`,
'se9b1fec72ffd8f48': `Vietinis`,
'sea24bdcaa2bd2dec': `Privalomas spragtelėjimas`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `Perjungia metaduomenų redaktorių`,
'sea896ed51ad33287': `Konkrečių stilių nėra`,
'seaaaeb09e3b4e78b': `Redagavimo komandos`,
'seabae79729c4b2ad': `Perjungti el. paštą`,
'seaecc8267bad6234': `Vidurinė mokykla`,
'seaf97719986faf4f': `Tarpas`,
'seb19675a580f0628': `Venkite stulpelio`,
'seb4e52ef5ec7a7dc': `Spalvos / efektai`,
'seb8982ae8c3cdcc5': `Indonezijos`,
'sebbced89e0db2894': `Pirmoji bazinė linija`,
'sec02109a0dd2a6c8': `Pabrėžta spalva`,
'sec2557a35b702525': `Kintamas`,
'sec2da4aa7a02b925': `Islandijos`,
'sec30fbb20f102670': `Įterpti santrauką`,
'sec8b0b6c729816b6': `Antraštės grupė`,
'seccd05955adb76bc': `Plakatas`,
'sed17285cd25d6389': `Katalogas, kuriame yra package.json`,
'sed318ec045c5144f': `Daugiau nei`,
'sed713f1b916fb469': `Atstumas tarp sienų (x)`,
'sed74a31b9172942c': `Atstumas tarp sienų (y)`,
'sed86bd0deb2e5372': `Transformuoti tekstą`,
'see2fcaedf9743ec6': `Vieta`,
'seec6798afe90ffc8': `Spausdinti`,
'sef00c258bc1ecf1e': `Šis tyrinėjamasis turi neišsaugotų pakeitimų.`,
'sef23dd271edd4a8b': `Apačioje kairėje`,
'sef24caccbd4645ef': `Lankstus susitraukimas`,
'sef49aec68fd1dc66': `Pavadinimas`,
'sef73fe18e351eb35': `Raktiniai žodžiai`,
'sef75f458d77491af': `Galimybių grupė`,
'sefcf950b3cc4fc3b': `Kalba`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Turinys`,
'sf0cab2483f66aa2e': `Pasirinktinis`,
'sf0e261e04eda82ff': `Išvaizda`,
'sf1045382c1fd9a85': `Tikslios spausdinimo spalvos`,
'sf14c35392ec7bf10': `"Firefox" ši funkcija nepasiekiama. Ją galima naudoti "Chrome" arba "Edge" naršyklėse.`,
'sf14f9d5f9f6ca342': `Plius žiebtuvėlis`,
'sf1868dc19e3917bb': `Ispanų kalba`,
'sf190149f9d8bbb2a': `Rašymo režimas`,
'sf1e79171c4856543': `Ar tikrai? Šio veiksmo negalima atšaukti, visi jūsų nustatymai bus ištrinti ir iš
          naujo nustatyti.`,
'sf21c1f60c7515f44': `Pažymėti pasirinkimą kaip pavyzdžio išvestį`,
'sf21fb4f4b9e8911f': `Plotis`,
'sf22a3737146ec910': `"WebWriter" gali įterpti SVG tiesiai į dokumentą.`,
'sf2514d5dc78b1654': `Įterpti valdiklį`,
'sf28903d4ca0ddcfc': `Pašalinti šią paskyrą`,
'sf2ab37af0abc55ef': `Paslėpti įvadinį turą`,
'sf2bdb0b4d7b9c039': `Bengalų kalba`,
'sf2cbb5e519264e67': `Pakeiskite dydį horizontaliai ir vertikaliai`,
'sf2d5cbc2fe0ad65a': `Sticky`,
'sf2d96d0eb32cb81f': `Animacijos kompozicija`,
'sf2de3dbe2108637a': `Formos atvaizdavimas`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Įterpti takelį`,
'sf3c4da68b08a2590': `Malagasių`,
'sf471ec2496f904cc': `Atmesti pakeitimus`,
'sf4849bc200e279ed': `Lentelės antraštė`,
'sf486ca1fdbe08645': `Įterpkite paveikslėlį`,
'sf4b537d4cbd8f5fd': `Teksto viršus`,
'sf4e0e02a5277ef23': `Tekstinės srities įterpimas`,
'sf4f067d41efd4b83': `Mastelis (y)`,
'sf4f3cbd41f002b46': `Mastelis (x)`,
'sf4fa67d41f05a008': `Mastelis (z)`,
'sf5197db2d5f2926a': `Pasukite`,
'sf52d840949a980d1': str`
          ${0}
          bus ištrintas visam laikui. Ar tikrai? 
        `,
'sf55d634dcc743595': `Paslaugos`,
'sf59c9081d106dd9c': `Pažymėti pasirinkimą kaip kintamąjį`,
'sf5e76f774beb33c2': `Inuktitutas`,
'sf64a8229a8136552': `Ištrinti dokumentą`,
'sf65df67a03bebe4b': `Būtinas šiam valdikliui`,
'sf6673729c03ae999': `Iš naujo nustatyti "WebWriter`,
'sf67571992e7dc88e': `Visas terminas`,
'sf6b4934598f7ed10': `Leisti pasirinkti`,
'sf6e1665c7022a1f8': `Slaptažodis`,
'sf79e0d78b56444f1': `Inline pabaiga`,
'sf7a5f7a7c80c3082': `Abu`,
'sf7c0eba7c822e3d6': `Drąsiai`,
'sf86bd4d2982f3b74': `Pažymėti pasirinkimą kaip kodą`,
'sf8e82313fa411494': `Pažymėti pasirinkimą kaip nuorodą`,
'sf955eff73fb6b573': `Serbų kalba`,
'sf9929e2d356260c5': `Dauginti`,
'sf993bb199fefbe04': `Visi`,
'sf9ecf969dd4b8164': `Abu kraštai`,
'sf9f2c719a04066ec': `Programėlė`,
'sfa49a5bb1a5d353e': `Privati prieiga`,
'sfa59c7777e2a0eeb': `Įterpti duomenų sąrašą`,
'sfaa0a67db5c11f72': `Pirmoji teksto eilutė`,
'sfb231a52211b133f': `Nėra teksto apvyniojimo`,
'sfb68cae41d749423': `Pradinis`,
'sfb9b6edb0ed378c9': `Citavimo šaltinis`,
'sfbbab09dbe553571': `Įterpti vektorinį piešinį (SVG)`,
'sfc00292e778b67e2': `Skaitiklis`,
'sfc63e31ac7c956ed': `Pasirinkite`,
'sfc815c9078bba30a': `Atsisiųsti QR kodą kaip paveikslėlį`,
'sfcdd8e672c75b713': `Adresas`,
'sfcebd18506f1e535': `Srautas`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Išėjimas`,
'sfdb1e4d90981a535': `Dalytis šiuo dokumentu`,
'sfdeef3dccf409f81': `Šis raktažodis reikalingas valdikliams`,
'sfe6e758ad2603c1d': `Magistro laipsnis`,
'sfee1c12daf838935': `Spalvų deginimas`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Įterpti dialogo langą`,
'sffa395f64ec6ac36': `Bulgarų`,
'sffdadf0a576fd802': `Aukštis`,
'spaceKey': `Erdvė`,
'tabKey': `⭾ Skirtukas`,
'upKey': `↑ Į viršų`,
's2739460e44320108': `Chinese (Traditional)`,
'scbf29ce484222325': ``,
    };
  